import { useMutation } from '@apollo/client';
import { UPDATE_USER_EMAIL } from '@monofront/business/queries';
import { useRouter } from 'next/router';
import { userService } from '@services/businessContainer';
import { EMAIL_INVALID_ERROR } from '@constants/user';
import useFirebaseErrors from '@hooks/vendor/useFirebaseErrors';
import { useLogout } from './useLogout';
import { toast } from 'react-toastify';
import { useTranslations } from 'next-intl';

// To be moved and refactored in the business lib
const useUpdateUserEmail = () => {
  const [updateEmail] = useMutation(UPDATE_USER_EMAIL);
  const { MAPPING_UPDATEUSER_ERROR } = useFirebaseErrors();
  const router = useRouter();
  const logout = useLogout();
  const gt = useTranslations('Global');

  return async ({ inputValue }: Record<string, any>) => {
    const validateUserEmail = await userService.validateEmail(inputValue);

    if (!validateUserEmail) {
      throw EMAIL_INVALID_ERROR;
    }

    return (
      // Update Email in Firebase Auth
      userService
        .updateEmail(inputValue)
        .then(() => {
          // Update Email in Firestore
          updateEmail().catch(() => {
            toast(gt('errorOccurredTryAgain'), {
              progressClassName: 'toast-error',
            });
          });
        })
        .catch((error) => {
          if (error.code === 'auth/requires-recent-login') {
            logout();
            router.push('/account/login');
          }
          throw new Error(MAPPING_UPDATEUSER_ERROR?.[error.code]);
        })
    );
  };
};

export default useUpdateUserEmail;
